import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { orderBy } from 'lodash';

import { withTranslation } from 'react-i18next';

// HighCharts
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsExport from 'highcharts/modules/exporting';
import HighchartsExportData from 'highcharts/modules/export-data';

// icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

// Provider
// import UserContext from '../../../../context/UserContext';

// init highcharts module
HighchartsExport(Highcharts);
HighchartsExportData(Highcharts);
Highcharts.setOptions({
  lang: {
    thousandsSep: ',',
  },
});

// export const t = (text) => <Trans>{text}</Trans>;

class DamChartDaily extends Component {
  // static contextType = UserContext;

  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      error: null,
      chartOptions: this.getChartOptions(),
    };
  }

  componentDidMount() {
    this.setState({ isLoading: true });

    const { chartCalType } = this.props;

    if (chartCalType !== 'sum') {
      this.renderChart();
    } else {
      this.renderChartSum();
    }
  }

  getChartOptions() {
    const { name, t } = this.props;

    // check user is login?
    const ctx = this.context;
    let userIsLogin = false;
    if (ctx) {
      userIsLogin = ctx.userIsLogin;
    }

    this.options = {
      chart: {
        style: {
          fontFamily: 'kanit',
        },
      },
      title: {
        text: `${name}`,
      },
      plotOptions: {
        line: {
          turboThreshold: 0,
        },
      },
      xAxis: {
        type: 'datetime',
        labels: {
          format: '{value:%b}',
        },
      },
      yAxis: { // Primary yAxis
        title: {
          text: t('ล้าน ลบ.ม.'),
        },
        labels: {
          format: '{value:,.0f}',
        },
        plotLines: [{
          value: null,
          color: 'red',
          dashStyle: 'shortdash',
          width: 2,
          label: {
            text: null,
            align: 'right',
          },
        }, {
          value: null,
          color: 'black',
          dashStyle: 'shortdash',
          width: 2,
          label: {
            text: null,
            align: 'right',
          },
        }, {
          value: null,
          color: '#f9a825',
          dashStyle: 'shortdash',
          width: 2,
          label: {
            text: null,
            align: 'left',
          },
        }],
      },
      tooltip: {
        crosshairs: true,
        shared: true,
        valueSuffix: t(' ล้าน ลบ.ม.'),
        xDateFormat: '%d %B',
      },
      // colors: ['#F62C2C', '#06C', '#39F', '#1AC9E6', '#7D3AC1', '#DB4CE2'],
      legend: {
        enabled: true,
      },
      series: [],
      exporting: {
        buttons: {
          contextButton: {
            enabled: userIsLogin,
            menuItems: [
              'printChart',
              'separator',
              'downloadPNG',
              'downloadJPEG',
              'downloadPDF',
              'downloadSVG',
              'separator',
              'downloadCSV',
              'downloadXLS',
            ],
          },
        },
      },
    };

    return this.options;
  }

  renderChart() {
    const {
      id,
      type,
      year,
      size,
      t,
    } = this.props;

    let url = `dam_yearly_graph?data_type=${type}&dam_id=${id}&year=${year}`;
    if (size === 'medium') {
      url = `dam_medium_graph?data_type=${type}&medium_id=${id}&year=${year}`;
    }

    // fetch data
    fetch(`${process.env.REACT_APP_API_URL}/analyst/${url}`)
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        return 'Something went wrong.';
      })
      .then((result) => {
        // transform datas
        const chartOptions = this.getChartOptions();
        const dataSeries = [];
        let ts = null;
        let val = null;

        // data series
        const colors = ['#F62C2C', '#06C', '#39F', '#1AC9E6', '#7D3AC1', '#DB4CE2', '#EA7369', '#F0A58F'];
        result.data.graph_data.reverse().map((d, i) => {
          const series = [];

          orderBy(d.data, ['date'], ['asc']).map((n) => {
            // by pass 29 Feb
            if ((moment(n.date).format('M') !== 2) && (moment(n.date).date() !== 29)) {
              if (n.value !== null) {
                val = parseFloat(n.value).toFixed(2);
              } else {
                val = null;
              }
              // console.log(`2020-${moment(n.date).format('MM')}-${moment(n.date).format('DD')}`);
              ts = moment(`2020-${moment(n.date).format('MM')}-${moment(n.date).format('DD')}`, 'YYYY/MM/DD').add(1, 'days').valueOf();
              series.push([ts, parseFloat(val)]);
            }

            return series;
          });

          dataSeries.push({
            name: `${d.year}`,
            data: series,
            color: colors[i],
            dashStyle: 'solid',
            tooltip: {
              valueSuffix: t(' ล้าน ลบ.ม.'),
              xDateFormat: '%d %B',
            },

          });

          return null;
        });

        // show rule curve for dam storage
        if (type === 'dam_storage') {
          // let valUpper = null;
          // let valLower = null;

          // // area chart
          // if (result.data.upper_rule_curve) {
          //   // upper rule curve
          //   const seriesRuleCurve = [];
          //   result.data.upper_rule_curve.map((n, i) => {
          //     if (n.value !== null) {
          //       valUpper = parseFloat(n.value).toFixed(2);
          //       valLower = parseFloat(result.data.lower_rule_curve[i].value).toFixed(2);
          //     } else {
          //       valUpper = null;
          //       valLower = null;
          //     }

          //     ts = moment(`2020-${moment(n.date).format('MM')}-${moment(n.date).format('DD')}`, 'YYYY-MM-DD').add(1, 'days').valueOf();
          //     seriesRuleCurve.push([ts, parseFloat(valLower), parseFloat(valUpper)]);

          //     return seriesRuleCurve;
          //   });

          //   dataSeries.push({
          //     name: 'Rule Curve',
          //     data: seriesRuleCurve,
          //     // type: 'arearange',
          //     type: 'line',
          //     lineWidth: 0,
          //     linkedTo: ':previous',
          //     color: Highcharts.getOptions().colors[0],
          //     fillOpacity: 0.2,
          //     zIndex: 0,
          //     marker: {
          //       enabled: false,
          //     },
          //   });
          // }

          // lower rule curve
          const seriesLower = [];
          result.data.lower_rule_curve.map((n) => {
            if (n.value !== null) {
              val = parseFloat(n.value).toFixed(2);
            } else {
              val = null;
            }

            ts = moment(`2020-${moment(n.date).format('MM')}-${moment(n.date).format('DD')}`, 'YYYY-MM-DD')
              .add(1, 'days')
              .valueOf();
            seriesLower.push([ts, parseFloat(val)]);

            return seriesLower;
          });

          dataSeries.push({
            name: 'Lower Rule Curve',
            data: seriesLower,
            tooltip: {
              valueSuffix: t(' ล้าน ลบ.ม.'),
              xDateFormat: '%d %B',
            },
            dashStyle: 'shortdot',
            color: '#7a7777',
          });

          // Upper rule curve
          const seriesUpper = [];
          result.data.upper_rule_curve.map((n) => {
            if (n.value !== null) {
              val = parseFloat(n.value).toFixed(2);
            } else {
              val = null;
            }

            ts = moment(`2020-${moment(n.date).format('MM')}-${moment(n.date).format('DD')}`, 'YYYY-MM-DD')
              .add(1, 'days')
              .valueOf();
            seriesUpper.push([ts, parseFloat(val)]);

            return seriesUpper;
          });

          dataSeries.push({
            name: 'Upper Rule Curve',
            data: seriesUpper,
            tooltip: {
              valueSuffix: t(' ล้าน ลบ.ม.'),
              xDateFormat: '%d %B',
            },
            dashStyle: 'shortdot',
            color: '#000',
          });

          // plotLines
          if (result.data.upper_bound) {
            chartOptions.yAxis.max = result.data.upper_bound;
            chartOptions.yAxis.plotLines[0].value = result.data.upper_bound;
            chartOptions.yAxis.plotLines[0].label.text = `${t('กักเก็บสูงสุด')} <strong>${result.data.upper_bound.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</strong> ${t('ล้าน ลบ.ม.')}`;
          }

          if (result.data.lower_bound) {
            chartOptions.yAxis.min = result.data.lower_bound;
            chartOptions.yAxis.plotLines[1].value = result.data.lower_bound;
            chartOptions.yAxis.plotLines[1].label.text = `${t('กักเก็บต่ำสุด')} <strong>${result.data.lower_bound.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</strong> ${t('ล้าน ลบ.ม.')}`;
          }

          if (result.data.normal_bound) {
            chartOptions.yAxis.plotLines[2].value = result.data.normal_bound;
            chartOptions.yAxis.plotLines[2].label.text = `${t('กักเก็บปกติ')} <strong>${result.data.normal_bound.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</strong> ${t('ล้าน ลบ.ม.')}`;
          }
        } else {
          chartOptions.yAxis.max = null;
          chartOptions.yAxis.min = null;
        }

        chartOptions.series = dataSeries;

        this.setState({ chartOptions, isLoading: false });
      })
      .catch((error) => this.setState({ error, isLoading: false }));
  }

  renderChartSum() {
    const {
      id,
      year,
      type,
      t,
    } = this.props;

    const url = `dam_daily_sum_region_rid?region_id=${id}&year=${year}`;
    const chartOptions = this.getChartOptions();

    // fetch data
    fetch(`${process.env.REACT_APP_API_URL}/analyst/${url}`)
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        return 'Something went wrong.';
      })
      .then((result) => {
        // transform datas
        const dataSeries = [];
        let ts = null;
        let val = null;

        // data series
        result.data.graph_data.map((d) => {
          const series = [];

          orderBy(d.data, ['date'], ['asc']).map((n) => {
            if (type === 'total_dam_storage') {
              val = n.total_dam_storage;
            } else if (type === 'total_dam_inflow') {
              val = n.total_dam_inflow;
            } else if (type === 'total_dam_released') {
              val = n.total_dam_released;
            } else if (type === 'total_dam_uses_water') {
              val = n.total_dam_uses_water;
            } else if (type === 'total_dam_inflow_acc') {
              val = n.total_dam_inflow_acc;
            } else if (type === 'total_dam_released_acc') {
              val = n.total_dam_released_acc;
            }

            // by pass 29 Feb
            if ((moment(n.dam_date).format('M') !== 2) && (moment(n.dam_date).date() !== 29)) {
              if (val === 0) {
                val = null;
              } else {
                val = parseFloat(val).toFixed(2);
              }

              // console.log(`2020-${moment(n.date).format('MM')}-${moment(n.date).format('DD')}`);
              ts = moment(`2020-${moment(n.dam_date).format('MM')}-${moment(n.dam_date).format('DD')}`, 'YYYY/MM/DD').add(1, 'days').valueOf();
              series.push([ts, parseFloat(val)]);
            }

            return series;
          });

          dataSeries.push({
            name: `${d.year}`,
            data: series,
            tooltip: {
              valueSuffix: t(' ล้าน ลบ.ม.'),
              xDateFormat: '%d %B',
            },
          });

          return null;
        });

        // set chart options
        chartOptions.series = dataSeries;

        // plotLines
        if (type === 'total_dam_storage') {
          if (result.data.bound.upper) {
            chartOptions.yAxis.max = result.data.bound.upper;
            chartOptions.yAxis.plotLines[0].value = result.data.bound.upper;
            chartOptions.yAxis.plotLines[0].label.text = `${t('กักเก็บสูงสุด')} <strong>${result.data.bound.upper.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</strong> ${t('ล้าน ลบ.ม.')}`;
          }

          if (result.data.bound.lower) {
            chartOptions.yAxis.min = result.data.bound.lower;
            chartOptions.yAxis.plotLines[1].value = result.data.bound.lower;
            chartOptions.yAxis.plotLines[1].label.text = `${t('กักเก็บต่ำสุด')} <strong>${result.data.bound.lower.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</strong> ${t('ล้าน ลบ.ม.')}`;
          }

          if (result.data.bound.normal) {
            chartOptions.yAxis.plotLines[2].value = result.data.bound.normal;
            chartOptions.yAxis.plotLines[2].label.text = `${t('กักเก็บปกติ')} <strong>${result.data.bound.normal.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</strong> ${t('ล้าน ลบ.ม.')}`;
          }
        } else {
          chartOptions.yAxis.max = null;
          chartOptions.yAxis.min = null;
        }

        this.setState({ chartOptions, isLoading: false });
      })
      .catch((error) => this.setState({ error, isLoading: false }));
  }

  render() {
    const { isLoading, error, chartOptions } = this.state;

    // if error, show error message
    if (error) {
      return (
        <div className="text-center">
          {error.message}
        </div>
      );
    }

    // if still loading, show spinner
    if (isLoading) {
      return (
        <div className="text-center">
          <FontAwesomeIcon icon={faSpinner} size="3x" />
        </div>
      );
    }

    return (
      <>
        <HighchartsReact
          highcharts={Highcharts}
          options={chartOptions}
        />
      </>
    );
  }
}

DamChartDaily.defaultProps = {
  id: '',
  chartCalType: '',
  size: 'large',
};

DamChartDaily.propTypes = {
  id: PropTypes.number,
  type: PropTypes.string.isRequired,
  year: PropTypes.instanceOf(Array).isRequired,
  name: PropTypes.string.isRequired,
  size: PropTypes.string,
  chartCalType: PropTypes.string,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(DamChartDaily);
